var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent0232(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFE4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 11.334L11.3334 20.6673M14 12.6673C14 13.4037 13.4031 14.0007 12.6667 14.0007C11.9303 14.0007 11.3334 13.4037 11.3334 12.6673C11.3334 11.9309 11.9303 11.334 12.6667 11.334C13.4031 11.334 14 11.9309 14 12.6673ZM20.6667 19.334C20.6667 20.0704 20.0698 20.6673 19.3334 20.6673C18.597 20.6673 18 20.0704 18 19.334C18 18.5976 18.597 18.0007 19.3334 18.0007C20.0698 18.0007 20.6667 18.5976 20.6667 19.334Z",
    stroke: "#F63D68",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent0232);
export default __webpack_public_path__ + "static/media/percent-02-32.3fa393a9ec67b71cc4d7c096f4b874a6.svg";
export { ForwardRef as ReactComponent };